import type { AccentPalette } from "../types";

export const ACCENT_FINANCIAL_ENTERPRISE: AccentPalette = {
    label: "Financial Enterprise",
    inflow: { base: "#33A589", selected: "#54C4A8" },
    outflow: { base: "#CC7E54", selected: "#DCA382" },
    icons: {
        "ri-account-circle-line": { pillHex: "#C9D9ED", chartHex: "#5B8AC8" },
        "ri-arrow-left-right-line": { pillHex: "#EDC9CF", chartHex: "#D27986" },
        "ri-bank-card-line": { pillHex: "#C9EDCF", chartHex: "#3EBB51" },
        "ri-bank-line": { pillHex: "#D9C9ED", chartHex: "#8B5BC8" },
        "ri-bill-line": { pillHex: "#EDE4C9", chartHex: "#D2BB79" },
        "ri-book-2-line": { pillHex: "#C9ECED", chartHex: "#3EB8BB" },
        "ri-bookmark-line": { pillHex: "#EDC9E2", chartHex: "#C85BA5" },
        "ri-box-3-line": { pillHex: "#D7EDC9", chartHex: "#9CD279" },
        "ri-briefcase-line": { pillHex: "#C9CDED", chartHex: "#3E4BBB" },
        "ri-building-line": { pillHex: "#EDD0C9", chartHex: "#C8705B" },
        "ri-calculator-line": { pillHex: "#C9EDDB", chartHex: "#79D2A4" },
        "ri-car-line": { pillHex: "#E5C9ED", chartHex: "#9F3EBB" },
        "ri-cash-line": { pillHex: "#EBEDC9", chartHex: "#C1C85B" },
        "ri-coins-line": { pillHex: "#C9E0ED", chartHex: "#79B2D2" },
        "ri-computer-line": { pillHex: "#EDC9D6", chartHex: "#BB3E6A" },
        "ri-exchange-dollar-line": { pillHex: "#CCEDC9", chartHex: "#61C85B" },
        "ri-file-list-3-line": { pillHex: "#D2C9ED", chartHex: "#8E79D2" },
        "ri-file-paper-2-line": { pillHex: "#EDDCC9", chartHex: "#BB803E" },
        "ri-funds-line": { pillHex: "#C9EDE7", chartHex: "#5BC8B4" },
        "ri-gift-line": { pillHex: "#EDC9E9", chartHex: "#D279C9" },
        "ri-government-line": { pillHex: "#DFEDC9", chartHex: "#89BB3E" },
        "ri-group-line": { pillHex: "#C9D4ED", chartHex: "#5B7CC8" },
        "ri-hammer-line": { pillHex: "#EDC9CA", chartHex: "#D2797B" },
        "ri-hand-coin-line": { pillHex: "#C9EDD3", chartHex: "#3EBB61" },
        "ri-home-8-line": { pillHex: "#DEC9ED", chartHex: "#995BC8" },
        "ri-landscape-line": { pillHex: "#EDE8C9", chartHex: "#D2C679" },
        "ri-lightbulb-line": { pillHex: "#C9E8ED", chartHex: "#3EA9BB" },
        "ri-line-chart-line": { pillHex: "#EDC9DD", chartHex: "#C85B98" },
        "ri-macbook-line": { pillHex: "#D3EDC9", chartHex: "#91D279" },
        "ri-megaphone-line": { pillHex: "#CAC9ED", chartHex: "#423EBB" },
        "ri-money-dollar-circle-line": { pillHex: "#EDD5C9", chartHex: "#C87D5B" },
        "ri-percent-line": { pillHex: "#C9EDDF", chartHex: "#79D2AF" },
        "ri-pie-chart-2-line": { pillHex: "#EAC9ED", chartHex: "#AF3EBB" },
        "ri-pie-chart-line": { pillHex: "#E6EDC9", chartHex: "#B3C85B" },
        "ri-printer-line": { pillHex: "#C9DCED", chartHex: "#79A7D2" },
        "ri-question-line": { pillHex: "#EDC9D1", chartHex: "#BB3E5B" },
        "ri-receipt-line": { pillHex: "#C9EDCC", chartHex: "#5BC862" },
        "ri-safe-line": { pillHex: "#D6C9ED", chartHex: "#9979D2" },
        "ri-scales-3-line": { pillHex: "#EDE1C9", chartHex: "#BB903E" },
        "ri-settings-4-line": { pillHex: "#C9EDEB", chartHex: "#5BC8C2" },
        "ri-shake-hands-line": { pillHex: "#EDC9E5", chartHex: "#D279BE" },
        "ri-shield-check-line": { pillHex: "#DAEDC9", chartHex: "#7ABB3E" },
        "ri-shopping-bag-3-line": { pillHex: "#C9D0ED", chartHex: "#5B6FC8" },
        "ri-stock-line": { pillHex: "#EDCDC9", chartHex: "#D28379" },
        "ri-store-2-line": { pillHex: "#C9EDD8", chartHex: "#3EBB70" },
        "ri-team-line": { pillHex: "#E2C9ED", chartHex: "#A65BC8" },
        "ri-time-line": { pillHex: "#EDEDC9", chartHex: "#D2D179" },
        "ri-timer-line": { pillHex: "#C9E3ED", chartHex: "#3E99BB" },
        "ri-tools-line": { pillHex: "#EDC9D9", chartHex: "#C85B8A" },
        "ri-truck-line": { pillHex: "#CFEDC9", chartHex: "#86D279" },
        "ri-umbrella-line": { pillHex: "#CFC9ED", chartHex: "#513EBB" },
        "ri-user-settings-line": { pillHex: "#EDD9C9", chartHex: "#C88B5B" },
        "ri-wallet-line": { pillHex: "#C9EDE4", chartHex: "#79D2BB" },
    },
};
